/**
 * getQuizResults.js
 * Written by: Alex Kasemir
 */
import request from '../../../request/actions';

export const GET_QUIZ_RESULTS_START = `GET_QUIZ_RESULTS_START`;
export const GET_QUIZ_RESULTS_SUCCESS = `GET_QUIZ_RESULTS_SUCCESS`;
export const GET_QUIZ_RESULTS_FAILURE = `GET_QUIZ_RESULTS_FAILURE`;

export const getQuizResultsStart = (id) => ({
  type: GET_QUIZ_RESULTS_START,
  id,
});

export const getQuizResultsSuccess = (id, results, hideTrueResult) => ({
  type: GET_QUIZ_RESULTS_SUCCESS,
  id,
  results,
  hideTrueResult,
});

export const getQuizResultsFailure = (id, error) => ({
  type: GET_QUIZ_RESULTS_FAILURE,
  id,
  error,
});

/**
 * Description of the getQuizResults action
 */
export const getQuizResults = (id, hideTrueResult = false) => {
  return async (dispatch) => {
    dispatch(getQuizResultsStart(id));
    try {
      const response = await dispatch(request(`/quizzes/${id}/results/`, `GET`));
      dispatch(getQuizResultsSuccess(response.data.quiz, response.data, hideTrueResult));
      return response;
    } catch (error) {
      dispatch(getQuizResultsFailure(id, error));
      return error.response;
    }
  };
};

export default getQuizResults;
